import { inject, observer } from 'mobx-react';
import { parse } from 'query-string';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { EmailNotificationDigestType } from '../../Models/IUser';
import { LoginWithFacebook } from '../../_components/LoginWithFacebook/LoginWithFacebook';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { isSuccessfulFacebookAuthResponse } from '../../_stores/AuthorizationStore';
import { assertIsString } from '../../util/string.utils';

import AuthPage from './AuthPage';
import SignupForm from './SignupForm';

interface IAccount {
    firstName: string,
    lastName: string,
    email: string,
    password: string
}

interface IServerErrorWarning {
    friendlyMessage?: string,
    message?: string
}

interface IState {
    account: IAccount;
    serverErrorWarning?: IServerErrorWarning;
    wasInvited: boolean;
    isSubmitting: boolean;
}

interface IProps {
    store: ApplicationStore;
}

@inject('store')
@observer
export class SignupPage extends React.Component<IProps & RouteComponentProps<any>, IState> {
    private _loginListenerDisposer = () => { return; };

    public state: IState = {
        account: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
        },
        wasInvited: false,
        isSubmitting: false,
    };

    public componentDidMount(): void {

        // TODO: Make sure invite process works properly
        if (this.props.location && this.props.location.search) {
            const query = this.props.location.search;
            const parsedQuery = parse(query);
            if (parsedQuery.invite_key && assertIsString(parsedQuery.invite_key) && assertIsString(parsedQuery.email)) {
                const inviteKey = decodeURIComponent(parsedQuery.invite_key);
                const email = decodeURIComponent(parsedQuery.email);
                this.setState({
                    account: {
                        email: email || '',
                        firstName: '',
                        lastName: '',
                        password: '',
                    }
                });
                this.setState({wasInvited: true});
                this.props.store.onboardingStore.setInvitedUserInformation(inviteKey, email);
            }
        }

        // TODO: Make sure invite process works properly
        if (this.props.location.state && this.props.location.state.signupInfo) {
            const { email, firstName, lastName, password } = this.props.location.state.signupInfo;
            this.setState({
                account: {
                    email: email || '',
                    firstName: firstName || '',
                    lastName: lastName || '',
                    password: password || '',
                }
            });
        }
    }

    public componentWillUnmount(): void {
        this._loginListenerDisposer();
    }


    private onClickFacebookLogin() {
        // console.log('onClickFacebookLogin');
    }

    private async responseFacebook(response: any) {
        console.log('responseFacebook: ', response);

        if (isSuccessfulFacebookAuthResponse(response)) {
            await this.props.store.authorizationStore.loginWithFacebook(response)
            .catch(err => this.handleAuthFailure(err));
        } else {
            this.handleAuthFailure(new Error('Invalid facebook api response'));
        }

    }

    private handleAuthFailure(error: any) {

        console.error('Auth Failure', error);
    }

    private handleSubmit = (isValid: boolean) => {
        this.setState({serverErrorWarning: {}});
        if (isValid) {
            this.setState({isSubmitting: true}, async () => {
                const {firstName, lastName, email, password} = this.state.account;
                const userExists = await this.props.store.authorizationStore.checkUserExists(email);
                if (userExists) {
                    this.setState({
                        serverErrorWarning: {
                            friendlyMessage: 'A user with that email address already exists.',
                            message: 'user-exists'
                        }
                    });
                    this.setState({isSubmitting: false});
                    return;
                }

                this.props.store.onboardingStore.setAccountInformation(firstName, lastName, email, password);
                this._loginListenerDisposer();

                this.props.store.onboardingStore.postAllOnboardingData()
                    .then(() => {
                        this.props.store.userProfileStore.updateNotificationFrequency(EmailNotificationDigestType.Daily);
                        this.props.history.push(Routes.ONBOARDING_WELCOME, {wasInvited: this.state.wasInvited});
                        this.setState({isSubmitting: false});
                    })
                    .catch((err) => {
                        console.error(err);
                        this.setState({
                            serverErrorWarning: {
                                friendlyMessage: 'That did not work',
                                message: 'unknown-error'
                            },
                            isSubmitting: false
                        });
                    });
            });
        }
    }

    private setAccount = (account: IAccount) => {
        this.setState({account});
    }

    public render() {

        return (

            <AuthPage>
                <h1 className="auth-page__card__header">Become a member, it's FREE!</h1>

                <SignupForm
                    account={this.state.account}
                    error={this.state.serverErrorWarning}
                    handleSubmit={this.handleSubmit}
                    isSubmitting={this.state.isSubmitting}
                    setAccount={this.setAccount}
                />
            </AuthPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/AuthPages/SignupPage.tsx